import Cookies from "js-cookie";

export default {
  setUserLogged(userLogged) {
    Cookies.set("userLogged", userLogged);
  },
  getUserLogged() {
    if(Cookies.get("userLogged")===undefined){
        window.location.href = '/#/login';
    }else{
         return Cookies.get("userLogged");
    }
  },
  deleteUserLogged() {
    Cookies.remove('userLogged');
  }

};

